const hostname = window.location.hostname
const firstDomain = hostname.split('.')[0]

let isUniversity = false
const universityDomainList = ['university', 'university-test', 'univ']
if (universityDomainList.includes(firstDomain)) {
  isUniversity = true
}
console.log('isUniversity: ', isUniversity)

export default isUniversity
